module.exports = __webpack_public_path__ + "static/media/thumb-up-blue-16.a182e634.svg";